import React from 'react';
import LegalLayout from './LegalLayout';
import { Mail, MessageCircle, MapPin, Send } from 'lucide-react';

const BOT_LINK = "https://t.me/instant_email_bot";
const CHANNEL_LINK = "https://t.me/freetelegramemail";
const CONTACT_EMAIL = "miiglobalpartner@gmail.com";

export default function ContactPage() {
  return (
    <LegalLayout
      title="Contact Us"
      metaTitle="Contact Us | TelegramEmailBot"
      metaDescription="Get in touch with the TelegramEmailBot team. Email support, Telegram chat, or visit our office in Penang, Malaysia. We typically reply within 24 hours."
      canonicalPath="/contact"
      testid="contact-page"
    >
      <p>
        We'd love to hear from you. Whether you need product help, want to partner, or have an enterprise question — pick the channel that suits you best.
      </p>

      <div className="not-prose grid sm:grid-cols-2 gap-4 my-8">
        <a
          href={BOT_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="group block border border-gray-200 rounded-2xl p-6 hover:border-[#0088CC] hover:shadow-md transition-all"
          data-testid="contact-card-telegram"
        >
          <Send className="w-6 h-6 text-[#0088CC] mb-3" />
          <h3 className="font-outfit font-bold text-base text-gray-900 mb-1">Telegram (fastest)</h3>
          <p className="font-manrope text-sm text-gray-500 mb-2">Chat with the bot directly — we usually reply in under an hour during business days.</p>
          <span className="font-manrope text-sm font-semibold text-[#0088CC] group-hover:underline">@instant_email_bot →</span>
        </a>

        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="group block border border-gray-200 rounded-2xl p-6 hover:border-[#0088CC] hover:shadow-md transition-all"
          data-testid="contact-card-email"
        >
          <Mail className="w-6 h-6 text-[#0088CC] mb-3" />
          <h3 className="font-outfit font-bold text-base text-gray-900 mb-1">Email Support</h3>
          <p className="font-manrope text-sm text-gray-500 mb-3">Support, billing, or general inquiries — we reply within one business day.</p>
          <p className="font-manrope text-base font-semibold text-[#0088CC] group-hover:underline break-all">{CONTACT_EMAIL}</p>
        </a>

        <a
          href={CHANNEL_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="group block border border-gray-200 rounded-2xl p-6 hover:border-[#0088CC] hover:shadow-md transition-all"
          data-testid="contact-card-support"
        >
          <MessageCircle className="w-6 h-6 text-[#0088CC] mb-3" />
          <h3 className="font-outfit font-bold text-base text-gray-900 mb-1">Support Channel</h3>
          <p className="font-manrope text-sm text-gray-500 mb-2">Public Telegram group for announcements, status and community questions.</p>
          <span className="font-manrope text-sm font-semibold text-[#0088CC] group-hover:underline">Join channel →</span>
        </a>

        <div className="block border border-gray-200 rounded-2xl p-6" data-testid="contact-card-office">
          <MapPin className="w-6 h-6 text-[#0088CC] mb-3" />
          <h3 className="font-outfit font-bold text-base text-gray-900 mb-1">Office</h3>
          <p className="font-manrope text-sm text-gray-500 leading-relaxed">
            Mii Global Partner Holdings Sdn. Bhd.<br />
            17, Taman Bukit Dumbar<br />
            Jelutong, Penang 11600<br />
            Malaysia
          </p>
        </div>
      </div>

      <h2>Response times</h2>
      <ul>
        <li><strong>Telegram chat</strong> — usually under 1 hour, Mon–Fri 9am–6pm (MYT)</li>
        <li><strong>Email</strong> — within 1 business day</li>
        <li><strong>Critical service issues</strong> — within 2 hours, any day</li>
      </ul>

      <h2>Business inquiries</h2>
      <p>
        Looking to white-label TelegramEmailBot, integrate it into your own product, or run a custom domain inbox at scale? Send us an email with a short brief — we'll get back the same day with a proposal.
      </p>
    </LegalLayout>
  );
}
